$(document).ready(function () {
  // var t = t || {}; t.money_format = "${{amount}}", t.formatMoney = function (t, e) { "string" == typeof t && (t = t.replace(".", "")); var o = "", n = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format; function i(t, e) { return void 0 === t ? e : t } function r(t, e, o, n) { if (e = i(e, 2), o = i(o, ","), n = i(n, "."), isNaN(t) || null == t) return 0; var a, r = (t = (t / 100).toFixed(e)).split("."); return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? n + r[1] : "") } switch (a.match(n)[1]) { case "amount": o = r(t, 2); break; case "amount_no_decimals": o = r(t, 0); break; case "amount_with_comma_separator": o = r(t, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": o = r(t, 0, ".", ",") }return a.replace(n, o) }, setInterval(function () { "-$0  [ 0%]" == $(".custome_discount_totl .shippin_d_text").text() ? $("span.free_shipping_d.custome_discount_totl").hide() : $("span.free_shipping_d.custome_discount_totl").show(), $.getJSON("/cart.js", function (e) { 100 > parseInt(t.formatMoney(e.total_price, "${{amount}}").replace("$", "").replace(".00", "")) ? $(".free_shipping_d.shipping_text_cutome").hide() : $(".free_shipping_d.shipping_text_cutome").show() }) }, 1e3)

  var t = t || {};
  t.money_format = "${{amount}}";
  t.formatMoney = function (t, e) { "string" == typeof t && (t = t.replace(".", "")); var o = "", n = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format; function i(t, e) { return void 0 === t ? e : t } function r(t, e, o, n) { if (e = i(e, 2), o = i(o, ","), n = i(n, "."), isNaN(t) || null == t) return 0; var a, r = (t = (t / 100).toFixed(e)).split("."); return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? n + r[1] : "") } switch (a.match(n)[1]) { case "amount": o = r(t, 2); break; case "amount_no_decimals": o = r(t, 0); break; case "amount_with_comma_separator": o = r(t, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": o = r(t, 0, ".", ",") }return a.replace(n, o) };

  /*
  setInterval(function () {
    if ($(".custome_discount_totl .shippin_d_text").text() == "-$0  [ 0%]") {
      $("span.free_shipping_d.custome_discount_totl").hide();
    } else {
      $("span.free_shipping_d.custome_discount_totl").show();
    }

    $.getJSON("/cart.js", function (e) {
      var price = t.formatMoney(e.total_price, "${{amount}}").replace("$", "").replace(".00", "");
      if (parseInt(price) < 100) {
        $(".free_shipping_d.shipping_text_cutome").hide();
      } else {
        $(".free_shipping_d.shipping_text_cutome").show();
      }
    });
  }, 1000);
  */

  // new accordian
  $(".customKloc_adone_info-new.headding_contentstest").click(function () {
    $(this).closest(".heading-addoneckk").toggleClass("selededt_main")
    $(this).closest(".customKloc_adone").find(".contents-addoneckk").toggleClass("active");

  });
  setInterval(function () {
    $(".contents-addoneckk").each(function () {
      var add_to_carts = $(this).find(".old-add-one-div buy-buttons.buy-buttons button.button div").text();
      var remove_text = add_to_carts.replace(" to cart", " ");
      var add_here = $(this).find("span#add_here:first").text();
      var allText = remove_text + "+ " + add_here;
      $(this).closest(".product.customKloc_adone").find(".add-one-reds").text(allText);
    })
  }, 500);
  // trigger
  $(".heading-addoneckk .add-one-reds").click(function () {
    $(this).closest(".product.customKloc_adone").find(".product-info__buy-buttons.old-add-one-div button.button.button--xl").trigger("click");
  })
  // First popup
  $(".Click-here-pre").on('click', function () {
    $(".custom-model-main-pre").addClass('model-open-pre');
  });
  $(".close-btn-pre, .bg-overlay-pre").click(function () {
    $(".custom-model-main-pre").removeClass('model-open-pre');
  });
  // Second popup

  $(".Click-here-prep").on('click', function () {
    $(".custom-model-main-prep").addClass('model-open-prep');
  });
  $(".close-btn-prep, .bg-overlay-prep").click(function () {
    $(".custom-model-main-prep").removeClass('model-open-prep');
  });

});

setInterval(function () {
  var iconeImg = document.getElementsByClassName('images_iconss');
  if (iconeImg.length > 0) {
  } else {
    $(".icartCheckoutWidgetMainDiv ").append("<img class='images_iconss' src='https://cdn.shopify.com/s/files/1/0274/6505/6326/files/Screenshot_2024-02-29_181838.png?v=1709210959' />");
  }
  var buttom_text = document.getElementsByClassName('buttom_inf_textnn');
  if (buttom_text.length > 0) {
  } else {
    $(".icartCheckoutWidgetMainDiv").append("<p class='buttom_inf_textnn'>Gauranteed Safe &amp; Secure Checkout</p>");
  }
  var upsellHd = document.getElementsByClassName('custome_heding_dta');
  if (upsellHd.length > 0) {
  } else {
    $(".icart-new-box.icart-border-bottam-new").prepend("<p class='custome_heding_dta'>Complete Your Kitchen</p>");
  }
}, 1000);


$(document).ready(function () {
  setInterval(function () {
    var textchk = $(".shopify-section--featured-product .HP_Featured_product .shopify-product-form .buy-buttons button.button.button--xl div").text();
    if ($('.shopify-section--featured-product .HP_Featured_product span.metta_varint_text').is(':empty') && textchk == "Pre-order") {
      $(".shopify-section--featured-product .HP_Featured_product .shopify-product-form .buy-buttons button.button.button--xl div").text("Add to cart");
    }
    if ($('.shopify-section--featured-product .HP_Featured_product .product-info__buy-buttons span.metta_varint_text').text() != '') {
      $(".shopify-section--featured-product .HP_Featured_product button.button.button--xl div").text("Pre-order");
    }
  }, 1000);

  // price updating single product on home page on chnages
  $(".shopify-section--featured-product .HP_Featured_product .custome_price_chnage").click(function () {
    setTimeout(function () {
      var price_main_discount_data = $(".shopify-section--featured-product .HP_Featured_product .product-info__price sale-price.text-lg").text();
      $("p.main_price_no_dis del").text(price_main_discount_data);

      var zerorem_data = price_main_discount_data.replace(".00", "");
      var sles_remov = zerorem_data.replace(",", "");
      var replace_coren = sles_remov.replace("$", "");
      var discount_prcnt_meta = $(".sucess_msg").attr("data-att");

      var multiplay = replace_coren * discount_prcnt_meta / 100;

      var final_real_pric = replace_coren - multiplay;

      var price_sqng = "$" + final_real_pric;
      $(".prie_chnages_data").text(price_sqng);

    }, 1000);
  })
})
setTimeout(function () {
  // new script Home page kl 17/10/2024
  var price_main_hmFirst = $(".HP_Featured_product .product-info__price sale-price.text-lg").text();
  var ret_home_furst = price_main_hmFirst.replace('.00', '');
  $('.HP_Featured_product buy-buttons.buy-buttons button.button div').after('<span id="add_here">' + ret_home_furst + '</span>');
}, 1000);

setInterval(function () {
  var price_main_Hme = $(".HP_Featured_product .product-info__price sale-price.text-lg").text();
  var ret_home = price_main_Hme.replace('.00', '');
  $('.HP_Featured_product buy-buttons.buy-buttons #add_here').text(ret_home);
}, 1100);          
